export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/client_problems')
    },

    async add(form) {
        return await $axios.post('/client_problems', form)
    },

    async fetchById(id) {
        return await $axios.get(`/client_problems/${id}`)
    },

    async update(form) {
        return await $axios.put(`/client_problems/${form.id}`, form)
    },

    async remove(id) {
        return await $axios.delete(`/client_problems/${id}`)
    },
})
